
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import AdminLogin from "../components/admin/AdminLogin";
import AdminDashboard from "../components/admin/AdminDashboard";
import { supabase } from "@/integrations/supabase/client";
import DynamicTitle from "@/components/DynamicTitle";
import { isAdminAuthenticated, adminLogout } from "@/services/adminAuthService";

export default function Admin() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  
  // Simplified admin user check (only for development purposes)
  useEffect(() => {
    const ensureAdminUserExists = async () => {
      try {
        // Check if admin user exists
        const { data: adminUsers, error: fetchError } = await supabase
          .from('admin_users')
          .select('*')
          .eq('username', 'admin');
          
        if (fetchError) {
          console.error("Error checking admin user:", fetchError);
          return;
        }
        
        // If admin user doesn't exist, create it
        if (!adminUsers || adminUsers.length === 0) {
          const { error: insertError } = await supabase
            .from('admin_users')
            .insert({
              username: 'admin',
              password_hash: 'password-will-be-hashed-by-trigger'
            });
            
          if (insertError) {
            console.error("Error creating admin user:", insertError);
          }
        }
      } catch (error) {
        console.error("Error in ensureAdminUserExists:", error);
      }
    };
    
    ensureAdminUserExists();
  }, []);
  
  // Check admin authentication on mount
  useEffect(() => {
    const checkAdminAuth = () => {
      setIsLoggedIn(isAdminAuthenticated());
      setIsLoading(false);
    };
    
    // Give a slight delay to ensure other operations complete
    setTimeout(checkAdminAuth, 100);
  }, [navigate]);

  // Handle admin logout
  const handleLogout = () => {
    adminLogout();
    setIsLoggedIn(false);
    navigate("/");
  };

  // Handle successful login
  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <DynamicTitle title="Admin Dashboard - Aram AI Content Management" />
      {isLoggedIn ? (
        <AdminDashboard onLogout={handleLogout} />
      ) : (
        <AdminLogin onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
}
